:host {
  display: inline-block;
}

:host([aria-disabled="true"]) label {
  color: var(--pine-color-text-label-disabled);
}

:host([aria-readonly="true"]) {
  label {
    color: var(--pine-color-text-label-readonly);
  }
}

label {
  color: var(--pine-color-text-label);
  font: var(--pine-typography-body-medium);
  letter-spacing: var(--pine-letter-spacing);
}
